(function ($) {

	function getUrlVars() {
		var vars = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}


	// Pagination
	$('.page-content').each(function () {
		var scrollClass = "sc-" + $(this).data("id");
		var $this = $(this).addClass('page-carousel').addClass(scrollClass);
		var $pageBreaks = $this.find('hr');
		var urlParams = getUrlVars();
		if ($pageBreaks.length === 0 || $('.pagemode-edit').length > 0 || urlParams["pdf"]=="1") return;

		//Solution 1
		/*$this.contents().filter(function () { return this.nodeType === 3 }).wrap('<p />');

		$pageBreaks.each(function (i) {
			var $this = $(this);
			if (i === 0) $this.prevAll().wrapAll('<div class="page active"/>');
			$this.nextUntil('hr').wrapAll('<div class="page"/>');
			$this.detach();
		});*/

		//Solution 2
		$pageBreaks.each(function() {
			$(this).removeAttr("class");
		});

		var pages = $this.html().split('<hr>');
		var newHTML = pages.map(function (page, i) {
			var active = (i == 0) ? ' active' : '';
			return '<div class="page' + active + ' ">' + page + '</div>';
		}).join('');
		$this.html(newHTML);

		var $pages = $this.find('.page');
		/* Append footer to each page */
		$pages.each(function (i) {
			if (i === 0) {
				$(this).append('<div class="page-footer"><p>Page ' + '<span class="currentPage" aria-current="page">' + (i + 1) + '</span>' + ' of ' + $pages.length + '</p></div>');
			}
			else {
				$(this).append('<div class="page-footer"></div>');
			}
		})
		/* Initialise carousel */
		if (jQuery().slick) {

			$this.slick({
				focusOnChange: true,
				focusOnSelect: false,
				accessibility: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				fade: false,
				dots: false,
				autoplay: false,
				adaptiveHeight: true,
				infinite: false,
				swipe: false,
				draggable: false,
				prevArrow: '<button class="slick-prev pagination-prev"><span class="visually-hidden">Previous page</span></button>',
				nextArrow: '<button class="slick-next pagination-next"><span class="visually-hidden">Next page</span></button>',
			});
		}

		$this.on('beforeChange', function (event, slick, direction) {
			var offset = ($(window).width() >= '1024') ? '100' : '30';
			var name;

			(name === 'true') ? 'Y' : 'N';
			$("body, html").animate({
				scrollTop: $("." + scrollClass).position().top - offset
			});
		});

		$this.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			//get and loop over all the pages within the carousel
			$pages = $this.find('.page');
			if (pages.length > 0) {
				$pages.each(function (index, element) {
					var $element = $(element);
					//the next slide
					if (index === nextSlide) {
						//insert pagination text
						$element.find('.page-footer').html('<p>Page ' + '<span class="currentPage" aria-current="page">' + (index + 1) + '</span>' + ' of ' + $pages.length + '</p>');
						//make all focusable elements focusable
						//$element.find('a, areabutton, details, input, frame, select, textarea').attr({ 'tabindex': '0' })
					}
					else {
						//clear pagination text for all slides except the next slide.
						$element.find('.page-footer').html('')
						//make all focusable elements not focusable for all slides except the next slide.
						//$element.find('a, areabutton, details, input, frame, select, textarea').attr({ 'tabindex': '-1' })
					}
				});
			}
		});

		$this.on('afterChange', function (event, slick, direction) {
			$pages = $this.find('.page');
			if (pages.length > 0) {
				$pages.attr({ 'tabindex': '-1' });
			}
		});
	});
})(jQuery);
